module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "h-6 w-6 stroke-current fill-current text-blue-dark",
    attrs: {
      "slot": "image",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 59.997 59.997"
    },
    slot: "image"
  }, [_c('path', {
    attrs: {
      "d": "M59.206.293a.999.999 0 0 0-1.414 0L54.084 4H30.802L1.532 33.511c-.667.666-1.034 1.553-1.034 2.495s.367 1.829 1.034 2.495l20.466 20.466a3.536 3.536 0 0 0 4.999-.01l28.501-29.271V5.414l3.707-3.707a1 1 0 0 0 .001-1.414zm-5.707 28.581L25.574 57.553a1.53 1.53 0 0 1-2.162 0L2.946 37.087c-.289-.289-.448-.673-.448-1.081s.159-.792.451-1.084L31.635 6h20.45l-4.833 4.833A4.969 4.969 0 0 0 44.499 10c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5a4.969 4.969 0 0 0-.833-2.753l4.833-4.833zm-6-13.874c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3c.462 0 .894.114 1.285.301l-1.992 1.992a.999.999 0 1 0 1.414 1.414l1.992-1.992c.187.391.301.823.301 1.285z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-481d9b86","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/svgs/ProductSVG.vue
// module id = 611
// module chunks = 66